// extracted by mini-css-extract-plugin
export default {"hed":"lk","blend":"mk","resultsBox":"nk","left":"ok","right":"pk","center":"qk","base":"rk","milk":"sk","text":"tk","hyroxresult":"uk","margin":"vk"};
    if(module.hot) {
      // 1713996739651
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  